import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { formatToString } from 'utils/formatMoney'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import { CURRENCIES } from 'constants/app-config'

const Commission = ({ commission = {} }) => {
  const { t } = useTranslation(['billing'])
  const { value = null, currency } = commission

  if (!value) {
    return null
  }

  return (
    <div className={styles['billing__calculated-data-item']}>
      {t('including_fee', {
        amount: formatToString(value, currency),
      })}
    </div>
  )
}

Commission.propTypes = {
  commission: PropTypes.shape({
    value: PropTypes.number,
    currency: PropTypes.oneOf(CURRENCIES),
  }),
}
export default Commission
